export default __webpack_public_path__ + "static/media/waiting_4.0e879ea3.png";